import { MODULE_NAMES } from "@/constants/modules.ts";
import { type ModuleName } from "@/types/modules";

const createAccessList = (record: Record<ModuleName, string>) =>
  Object.fromEntries(
    Object.entries(record).map(([key, value]) => [
      MODULE_NAMES[key as ModuleName],
      value,
    ]),
  );

export const accessList = createAccessList({
  ACCESS_LEVELS: "AccessLevel",
  APPLE_MODELS: "AppleModel",
  APP_VERSION_FLAGS: "AppVersionFlag",
  CAMPAIGNS: "Campaign",
  CAMPAIGN_TDS: "CampaignTds",
  CLIENT_APPS: "ClientApp",
  COUNTRIES: "Country",
  DEVICE_TYPES: "DeviceType",
  GROUPS: "Group",
  LANDINGS: "Landing",
  LEAD_REPORT: "LeadReport",
  MAIL_SUBJECTS: "MailSubject",
  OS: "DictionaryOs",
  PAYMENT_PROVIDER_MODELS: "PaymentProviderModel",
  RADIUS_VPN_SERVERS: "RadiusVpnServer",
  RECEIPTS: "Receipt",
  ROLES: "Role",
  TARIFFS: "Tariff",
  TICKETS: "Ticket",
  TRACKERS: "Tracker",
  TRAFFIC_SOURCES: "TrafficSource",
  USERS: "User",
  CITIES: "City",
  REBILLS: "RebillAnalytics",
  REBILLS_GROUPS: "RebillAnalytics",
  LANDING_REGIONS: "LandingRegion",
  LANDING_DOMAINS: "LandingDomain",
  DATA_CENTERS: "DataCenter",
  BLACKLIST_DEVICES: "BlacklistDevice",
  STATISTICS: "CommonStatistics",
  STATISTICS_GROUPS: "CommonStatistics",
  PREMIUM_ISSUANCE: "PremiumIssuance",
  RESEND_PROMO: "EmployeePromoResent",
  COUNTRY_PRICES: "CountryPrice",
});
